import { createAction } from "@ngrx/store";

export const LOAD = createAction(
  '[load state] load state'
)
